
import Toggler from '../toggler/Toggler';
document.addEventListener('DOMContentLoaded', () => {

  const togglerButtons = document.querySelectorAll('[data-toggler]');

  togglerButtons.forEach(button => {
    const targetId = button.getAttribute('data-toggler');
    const target = document.getElementById(targetId);

    if (target) {
      const group = button.getAttribute('data-group');
      const autoClose = button.getAttribute('data-autoclose') === 'true';

      const togglerInstance = new Toggler(button, target, autoClose, group);

      const originalHide = togglerInstance.hide.bind(togglerInstance);

      togglerInstance.hide = function() {
        originalHide(true);
      };

      togglerInstance.mount();
    }
  });
});
